import { Container, Row } from "reactstrap";
import ColoredBreadcrumb from "./ColoredBreadcrumb";
import DefaultBreadcrumb from "./DefaultBreadcrumb";
import DividerBreadcrumb from "./DividerBreadcrumb";
import VariationBreadcrumb from "./VariationBreadcrumb";
import WithIconBreadcrumb from "./WithIconBreadcrumb";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, BreadcrumbTitle } from "../../../Constants/Constants";

const BreadcrumbContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={BreadcrumbTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <DefaultBreadcrumb />
          <DividerBreadcrumb />
          <WithIconBreadcrumb />
          <VariationBreadcrumb />
          <ColoredBreadcrumb />
        </Row>
      </Container>
    </>
  );
};
export default BreadcrumbContainer;
